(() => {
  const root = window.Shopify?.routes?.root || "/";
  const currency = window.Shopify?.currency?.active || "USD";
  const formatMoney = (cents) => new Intl.NumberFormat(document.documentElement.lang || "en-US", { style: "currency", currency }).format((Number(cents) || 0) / 100);
  const escapeHTML = (value = "") => String(value).replace(/[&<>'"]/g, (character) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", "'": "&#39;", '"': "&quot;" }[character]));

  const menu = document.querySelector(".drawer--menu");
  const cart = document.querySelector(".drawer--cart");
  const search = document.querySelector(".search-overlay");
  const globalScrim = document.querySelector(".scrim-global");
  const header = document.querySelector("[data-site-header]");

  const closeOverlays = () => {
    [menu, cart, search].forEach((node) => {
      node?.classList.remove("is-open");
      node?.setAttribute("aria-hidden", "true");
    });
    globalScrim?.classList.remove("is-open");
    document.body.classList.remove("has-overlay");
  };

  const openOverlay = (node) => {
    closeOverlays();
    node?.classList.add("is-open");
    node?.setAttribute("aria-hidden", "false");
    if (node !== search) globalScrim?.classList.add("is-open");
    document.body.classList.add("has-overlay");
  };

  document.querySelectorAll("[data-open-menu]").forEach((button) => button.addEventListener("click", () => openOverlay(menu)));
  document.querySelectorAll("[data-open-cart]").forEach((button) => button.addEventListener("click", () => openOverlay(cart)));
  document.querySelectorAll("[data-open-search]").forEach((button) => button.addEventListener("click", () => {
    openOverlay(search);
    window.setTimeout(() => search?.querySelector("input")?.focus(), 500);
  }));
  document.querySelectorAll("[data-close-overlays]").forEach((button) => button.addEventListener("click", closeOverlays));
  document.addEventListener("keydown", (event) => { if (event.key === "Escape") closeOverlays(); });

  document.querySelector("[data-close-announcement]")?.addEventListener("click", () => document.querySelector("[data-announcement-bar]")?.classList.add("is-hidden"));

  const updateHeader = () => {
    const threshold = document.body.classList.contains("page-home") || document.body.classList.contains("page-lookbook") ? 75 : 0;
    header?.classList.toggle("is-scrolled", window.scrollY > threshold);
  };
  window.addEventListener("scroll", updateHeader, { passive: true });
  updateHeader();

  if (document.body.classList.contains("page-home") && !window.Shopify?.designMode) {
    document.body.classList.add("is-loading");
    const loader = document.createElement("div");
    loader.className = "loader";
    loader.setAttribute("aria-hidden", "true");
    const logo = document.querySelector(".brand img")?.src || "";
    loader.innerHTML = `<img class="loader__mark" src="${escapeHTML(logo)}" alt=""><span class="loader__line"></span>`;
    document.body.prepend(loader);
    window.addEventListener("load", () => window.setTimeout(() => {
      loader.classList.add("is-hidden");
      document.body.classList.remove("is-loading");
    }, 850));
  }

  const renderCart = (cartState) => {
    document.querySelectorAll("[data-bag-count]").forEach((node) => { node.textContent = `(${cartState.item_count})`; });
    const container = document.querySelector("[data-cart-content]");
    if (!container) return;
    if (!cartState.item_count) {
      container.className = "drawer__empty";
      container.innerHTML = `<p>Your bag is empty.</p><span>Discover the latest MIRZA collection.</span><a class="line-link line-link--dark" href="${root}collections/new-collection"><span>Explore the collection</span><i>↗</i></a>`;
      return;
    }
    container.className = "";
    container.innerHTML = cartState.items.map((item) => `
      <article class="cart-item">
        ${item.image ? `<img src="${escapeHTML(item.image)}&width=190" alt="${escapeHTML(item.product_title)}" width="95" height="125">` : ""}
        <div><h3>${escapeHTML(item.product_title)}</h3><p>${escapeHTML(item.variant_title || "")}</p><p>Quantity ${item.quantity}</p><strong>${formatMoney(item.final_line_price)}</strong></div>
      </article>`).join("") + `<a class="solid-button" style="width:100%;margin-top:24px" href="${root}cart">View bag <span>↗</span></a>`;
  };

  const refreshCart = async () => {
    const response = await fetch(`${root}cart.js`, { headers: { Accept: "application/json" } });
    if (!response.ok) throw new Error("Unable to load bag");
    const cartState = await response.json();
    renderCart(cartState);
    return cartState;
  };

  const addVariant = async (variantId, quantity = 1) => {
    const response = await fetch(`${root}cart/add.js`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity }] })
    });
    if (!response.ok) {
      const error = await response.json().catch(() => ({}));
      throw new Error(error.description || "This piece could not be added.");
    }
    await refreshCart();
    openOverlay(cart);
  };

  document.addEventListener("click", async (event) => {
    const quickAdd = event.target.closest("[data-quick-add]");
    if (!quickAdd) return;
    event.preventDefault();
    event.stopPropagation();
    quickAdd.setAttribute("aria-busy", "true");
    try { await addVariant(quickAdd.dataset.quickAdd); }
    catch (error) { window.alert(error.message); }
    finally { quickAdd.removeAttribute("aria-busy"); }
  });

  document.querySelectorAll("[data-product-root]").forEach((productRoot) => {
    const form = productRoot.querySelector("[data-product-form]");
    const variantsJSON = form?.querySelector("[data-product-variants]")?.textContent;
    if (!form || !variantsJSON) return;
    const variants = JSON.parse(variantsJSON);
    const hiddenVariant = form.querySelector("[data-variant-id]");
    const addButton = form.querySelector(".product-add");
    const addLabel = form.querySelector("[data-add-label]");
    const addPrice = form.querySelector("[data-add-price]");
    const mainPrice = productRoot.querySelector("[data-product-price]");
    const comparePrice = productRoot.querySelector("[data-product-compare-price]");
    const message = form.querySelector("[data-product-message]");

    const updateVariant = () => {
      const selections = [...form.querySelectorAll(".option-group")].map((group) => group.querySelector("input:checked")?.value);
      const variant = variants.find((candidate) => candidate.options.every((option, index) => option === selections[index]));
      form.querySelectorAll(".option-group").forEach((group) => {
        const checked = group.querySelector("input:checked");
        group.querySelector("[data-option-label]").textContent = checked?.value || "";
        group.querySelectorAll("label").forEach((label) => label.classList.toggle("is-active", label.contains(checked)));
      });
      if (!variant) {
        addButton.disabled = true;
        addLabel.textContent = "Unavailable";
        return;
      }
      hiddenVariant.value = variant.id;
      addButton.disabled = !variant.available;
      addLabel.textContent = variant.available ? "Add to bag" : "Sold out";
      addPrice.textContent = formatMoney(variant.price);
      mainPrice.textContent = formatMoney(variant.price);
      if (comparePrice) {
        const isSale = variant.compare_at_price && variant.compare_at_price > variant.price;
        comparePrice.hidden = !isSale;
        comparePrice.textContent = isSale ? formatMoney(variant.compare_at_price) : "";
      }
      const url = new URL(window.location.href);
      url.searchParams.set("variant", variant.id);
      window.history.replaceState({}, "", url);
    };

    form.addEventListener("change", updateVariant);
    form.addEventListener("submit", async (event) => {
      event.preventDefault();
      message.textContent = "";
      addButton.disabled = true;
      try { await addVariant(hiddenVariant.value); }
      catch (error) { message.textContent = error.message; }
      finally { updateVariant(); }
    });
  });

  const filterPanel = document.querySelector(".filter-panel");
  const filterScrim = document.querySelector(".scrim");
  document.querySelector("[data-filter-trigger]")?.addEventListener("click", () => {
    filterPanel?.classList.add("is-open");
    filterPanel?.setAttribute("aria-hidden", "false");
    filterScrim?.classList.add("is-open");
    document.body.classList.add("has-overlay");
  });
  document.querySelectorAll("[data-filter-close]").forEach((button) => button.addEventListener("click", () => {
    filterPanel?.classList.remove("is-open");
    filterPanel?.setAttribute("aria-hidden", "true");
    filterScrim?.classList.remove("is-open");
    document.body.classList.remove("has-overlay");
  }));
  document.querySelector("[data-sort-select]")?.addEventListener("change", (event) => event.target.form?.submit());

  const revealElements = () => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      document.querySelectorAll(".reveal").forEach((node) => node.classList.add("is-visible"));
      return;
    }
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-visible");
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: "0px 0px -6%" });
    document.querySelectorAll(".reveal:not(.is-visible)").forEach((node) => observer.observe(node));
  };
  revealElements();
  document.addEventListener("shopify:section:load", revealElements);
})();
